// @flow

import React from 'react'
import Moment from 'react-moment'

export const Date = ({ value }: { value: any }) => {
  return (<Moment format="YYYY-MM-DD HH:mm" local>{value}</Moment>)
}
